import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from "react";
import { ContactPage } from "./pages/ContactPage";
import ThankYouPage from "./pages/ThankYouPage";
import ConfirmRequestCancellation from "./pages/ConfirmRequestCancellationPage";

const AppRouter: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<ContactPage />} />
                <Route path="/thank-you-created" element={<ThankYouPage />} />

                <Route
                    path="/confirm-request-cancellation"
                    element={<ConfirmRequestCancellation />}
                />
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter;
